import React from 'react';
import Grid from './common/Grid';
import ServiceCard from './ServiceCard';

const ServiceGrid = ({ services, onAddClick, onEdit, onDelete, onServiceClick }) => {
  return (
    <Grid
      items={services}
      renderCard={(service) => (
        <ServiceCard
          service={service}
          onEdit={onEdit}
          onDelete={onDelete}
          onClick={onServiceClick}
        />
      )}
      onAddClick={onAddClick}
      square={true}
    />
  );
};

export default ServiceGrid;
